<template>
  <Dialog v-model:visible="dialogVisible" :header="titulo" modal :style="{ width: '28rem' }" :closable="true"
    :draggable="false">
    <div class="flex flex-column gap-3">
      <div class="flex align-items-center gap-2">
        <Tag :value="statusConfig.label" :severity="statusConfig.severity" :icon="statusConfig.icon" />
        <span v-if="mensagemDias" class="text-sm text-600">{{ mensagemDias }}</span>
      </div>

      <div class="flex flex-column gap-2">
        <div class="flex align-items-center gap-2">
          <i class="pi pi-calendar text-500"></i>
          <span class="font-medium text-700">Início:</span>
          <span class="text-600">{{ dataInicioFormatada }}</span>
        </div>
        <div class="flex align-items-center gap-2">
          <i class="pi pi-calendar-times text-500"></i>
          <span class="font-medium text-700">Prazo final:</span>
          <span class="text-600">{{ dataFimFormatada }}</span>
        </div>
      </div>

      <div v-if="expirado" class="border-round p-3 bg-red-50 text-red-700 flex align-items-start gap-2">
        <i class="pi pi-exclamation-circle mt-1"></i>
        <div>
          <strong>Prazo expirado!</strong>
          <p class="m-0 mt-1 text-sm">
            Entre em contato com a coordenação do seu curso para obter mais informações.
          </p>
        </div>
      </div>

      <div v-else-if="alerta" class="border-round p-3 bg-yellow-50 text-yellow-800 flex align-items-start gap-2">
        <i class="pi pi-exclamation-triangle mt-1"></i>
        <div>
          <strong>Atenção: prazo se aproximando!</strong>
          <p class="m-0 mt-1 text-sm">
            Restam poucos dias para o encerramento do período.
          </p>
        </div>
      </div>
    </div>

    <template #footer>
      <Button label="Fechar" severity="secondary" @click="dialogVisible = false" />
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import {
  formatDateBR,
  getMensagemDiasRestantes,
  getStatusPrazoConfig,
  isPrazoExpirado,
  type StatusPrazoConfig,
} from '@/utils/statusPrazoUtils';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Tag from 'primevue/tag';
import { computed } from 'vue';

interface Props {
  visible: boolean;
  titulo?: string;
  dataInicio?: string | null;
  dataFim?: string | null;
  statusPrazo?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  titulo: 'Período do TCC',
  dataInicio: null,
  dataFim: null,
  statusPrazo: null,
});

const emit = defineEmits<{
  'update:visible': [value: boolean];
}>();

const dialogVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value),
});

const statusConfig = computed<StatusPrazoConfig>(() => getStatusPrazoConfig(props.statusPrazo));
const dataInicioFormatada = computed(() => formatDateBR(props.dataInicio));
const dataFimFormatada = computed(() => formatDateBR(props.dataFim));
const mensagemDias = computed(() => getMensagemDiasRestantes(props.dataFim));
const expirado = computed(() => isPrazoExpirado(props.statusPrazo));
const alerta = computed(() => props.statusPrazo === 'alerta');
</script>
